module.exports = __webpack_public_path__ + "static/media/ripan.a3b087e5.png";